import React, { useCallback } from 'react'
import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { actionCreators } from '@/store/ReportSubmissions'
import { preventAndStop } from '@/components/report-tables/core/utils'
import Icon from '@/components/Icon'
import { Popover } from '@/components/popover'
import classnames from 'classnames'
import { useLocalization } from '@/hooks/localization'
import { reportCellCommentStatus } from '@/enums/reportCellCommentStatus'
import getEnumTranslation from '@/enums/enums'
import { Badge } from 'reactstrap'
import { truncate } from '@/utils/StringUtilities'
import { reportPopOverMaxTextLength } from '@/utils/constants'

function getCommentClass (commentStatus) {
  return classnames(['cell-btn', { 'resolved': commentStatus === 1 }])
}

function getTooltipContent (localize, comment, commentStatus) {
  const status = getEnumTranslation({ localize, enumName: reportCellCommentStatus.enumName, value: commentStatus }).toUpperCase()
  const color = commentStatus === 1 ? 'success' : 'primary'
  return (
    <React.Fragment>
      {truncate(localize(comment), reportPopOverMaxTextLength)}
      <br />
      <h6><Badge pill color={color}>{status}</Badge></h6>
    </React.Fragment>
  )
}

export function CommentButtons ({ commentMode, comment, commentStatus, ...props }) {
  const { localize } = useLocalization()

  const viewComment = useCallback(() => {
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.alert,
      title: 'Common.Comment',
      content: localize(comment)
    }))
  }, [comment, localize])

  if (commentMode === 'editable') {
    return <EditableCommentButtons comment={comment} commentStatus={commentStatus} {...props} />
  }
  // readonly comments
  return comment
    ? <Popover placement='left' content={getTooltipContent(localize, comment, commentStatus)}>
      <span onClick={viewComment} onMouseDown={preventAndStop} className={getCommentClass(commentStatus)}>
        <Icon name='message' />
      </span>
    </Popover>
    : null
}

function EditableCommentButtons ({ colId, rowId, col, row, comment, commentStatus }) {
  const { localize } = useLocalization()
  const setComment = useCallback(() => {
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.cellComment,
      title: 'Reporting.CommentDialogTitle',
      value: comment,
      status: commentStatus,
      onAction: ({ value, status }) => {
        getStore().dispatch(actionCreators.setCellComment(colId, rowId, col, row, value, status))
      }
    }))
  }, [col, colId, comment, commentStatus, row, rowId])

  const removeComment = useCallback(() => {
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.confirm,
      title: 'Common.RemoveCommentTitle',
      content: 'Common.RemoveCommentConfirm',
      onAction: () => {
        getStore().dispatch(actionCreators.setCellComment(colId, rowId, col, row, null))
      }
    }))
  }, [col, colId, row, rowId])

  if (!comment) {
    return (
      <button onClick={setComment} className='cell-btn' onMouseDown={preventAndStop}><Icon name='plus' /></button>
    )
  }
  return (
    <React.Fragment>
      <Popover placement='left' content={getTooltipContent(localize, comment, commentStatus)}>
        <span onClick={setComment} onMouseDown={preventAndStop} className={getCommentClass(commentStatus)}>
          <Icon name='pencil' />
        </span>
      </Popover>
      <button onClick={removeComment} onMouseDown={preventAndStop} className='cell-btn red'>
        <Icon name='trash-alt' />
      </button>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/report-tables/renderers/cellButtons/commentButtons.js